<ngb-accordion>
  <ng-container *ngFor="let panel of panels">
    <ngb-panel [title]="panel.heading" class="accordion-header" *ngIf="panel.body">
      <ng-template ngbPanelContent>
        <div [innerHTML]="panel.body"></div>
      </ng-template>
    </ngb-panel>
  </ng-container>
</ngb-accordion>
